
import { defineComponent, watch, onErrorCaptured, ref } from 'vue'
import { IonText } from '@modus/ionic-vue'
import { useRouter, RouterView } from 'vue-router'
import Skeleton from '@/components/Skeleton.vue'

import '@ionic/core/css/normalize.css'
import '@ionic/core/css/core.css'
import '@ionic/core/css/structure.css'
import '@ionic/core/css/typography.css'
import '@ionic/core/css/ionic.bundle.css'

export default defineComponent({
  name: 'App',
  components: {
    IonText,
    RouterView,
    Skeleton,
  },
  setup() {
    const error = ref()
    const { currentRoute } = useRouter()

    watch(currentRoute, (to) => {
      document.title = to.meta.title || 'Vue-Port Shop'
    })

    onErrorCaptured((err) => {
      error.value = err as string
    })

    return {
      error,
    }
  },
})
